import React from 'react';
import { PageStats } from '../../components/PageStats';
import { GetServerSideProps } from 'next';
import { getServerSidePropsWithAuth } from '../../utils/authServerSideProps';
import { IStatPassConditionContext } from '../../context/app';

// export const getServerSideProps: GetServerSideProps = getServerSidePropsWithAuth

const statsCondition: IStatPassConditionContext = {
  isOverStats: false,
};

export default function BreakerPage() {
  return <PageStats title="Łamak" tooltipText="Łamak" statName="breaker.normal" seoTitle="Łamak" statsCondition={statsCondition} />;
}
